<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="猪只类别" prop="pig_type_id">
              <Select v-model="formData.pig_type_id" placeholder="请选择猪只类别" class="perW30">
                <Option v-for="(item,key) in pigTypeList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="猪只品种" prop="pig_variety_id">
              <Select v-model="formData.pig_variety_id" placeholder="请选择猪只品种" class="perW30">
                <Option v-for="(item,key) in pigVarietyList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="耳标编号" prop="tag_sn">
              <Input placeholder="请输入耳标编号" class="perW30" v-model="formData.tag_sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="常用药品" prop="">
              <RadioGroup v-model="formData.category">
                <Radio v-for="item in drugs" :label="item" ></Radio>
              </RadioGroup>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="用药品类" prop="category">
              <Input placeholder="请输入用药品类" class="perW30" v-model="formData.category"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="用药剂量" prop="dosage">
              <Input placeholder="请输入用药剂量" class="perW30" v-model="formData.dosage"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="注意事项" prop="info">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入注意事项" class="perW30"
                     v-model="formData.info"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="不良反应" prop="reaction">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入不良反应" class="perW30"
                     v-model="formData.reaction"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="用药日期" prop="date">
              <DatePicker type="date" placeholder="请选择日期" class="perW30" v-model="formData.date"></DatePicker>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submitFormData">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {pigMedicineDetailApi, pigMedicineSaveApi} from '@/api/pigFarm/pigMedicine'
import {pigTypeAllApi} from '@/api/pigFarm/pigType'
import {pigVarietyAllApi} from '@/api/pigFarm/pigVariety'
import {validateTagSn} from "@/utils/utils";

export default {
  name: 'pigMedicineEdit',
  data() {
    return {
      drugs: [
        "庆大霉素",
        "恩诺沙星",
        "白头翁散",
        "杨树花口服液",
        "头孢",
        "青霉素",
        "链霉素",
        "林可霉素",
        "大观霉素",
        "双黄连",
        "柴胡",
        "氨基比林",
        "卡那霉素",
        "泰妙菌素",
        "氟苯尼考",
        "替米考星",
        "泰万菌素",
        "泰乐菌素",
        "免疫球蛋白",
        "干扰素",
        "血清抗体",
        "板清颗粒",
        "弱毒苗",
        "灭活苗",
        "冻干苗",
        "液体苗",
        "干粉苗",
        "油乳剂苗",
        "组织苗",
        "细胞苗",
        "联合疫苗",
        "多价疫苗",
        "三联苗",
        "脾淋苗"
      ],
      formData: {
        pig_medicine_id: 0,
        pig_type_id: 0,
        pig_variety_id: 0,
        tag_sn: '',
        dosage: '',
        category: '',
        date: '',
        info: '',
        reaction: '',
      },
      ruleValidate: {
        pig_type_id: [
          {required: true, message: '请选择猪只类别', trigger: 'change'}
        ],
        pig_variety_id: [
          {required: true, message: '请选择猪只品种', trigger: 'change'}
        ],
        tag_sn: [
          {required: true, message: '请输入耳标编号', trigger: 'blur'},
          {validator: validateTagSn, trigger: 'blur'},
        ],
        category: [
          {required: true, message: '请输入用药品类', trigger: 'blur'}
        ],
        dosage: [
          {required: true, message: '请输入用药剂量', trigger: 'blur'}
        ],
        info: [
          {required: true, message: '请输入注意事项', trigger: 'blur'}
        ],
        reaction: [
          {required: true, message: '请输入不良反应', trigger: 'blur'}
        ],
        date: [
          {required: true, type: 'date', message: '请选择用药日期', trigger: 'change'}
        ],
      },
      pigTypeList: [],
      pigVarietyList: [],
    }
  },
  mounted() {
    this.loadPigTypeData()
    this.loadPigVarietyData()
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    //提交数据
    submitFormData() {
      // 验证表单数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          // 验证失败 停止提交
          this.$Message.error('请检查输入内容!');
          return false;
        } else {
          // 验证通过 请求接口
          pigMedicineSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 编辑加载数据
    loadFormData(id) {
      pigMedicineDetailApi(id).then(res => {
        //数据赋值
        this.formData = res.data

        // 字符串转换
        this.formData.pig_type_id = this.formData.pig_type_id.toString()
        this.formData.pig_variety_id = this.formData.pig_variety_id.toString()

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 获取猪类别
    loadPigTypeData() {
      pigTypeAllApi().then(res => {
        if (res.code === 200) {
          this.pigTypeList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 获取猪品种
    loadPigVarietyData() {
      pigVarietyAllApi().then(res => {
        if (res.code === 200) {
          this.pigVarietyList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
